import $http from '../../shared/http';
import { downloadFileFromResponse } from '../../shared/utils';

export const downloadable_files = {
  namespaced: true,
  state: () => {
    return {
      form: null,
    };
  },
  mutations: {
    setDownloadableFileData: (state, payload) => (state.form = payload),
  },
  actions: {
    async createDownloadableFileAction(_ctx, { form }) {
      return $http('v2', { isMultipartData: true }).post(`downloadable_files`, form, {
        notifiable: true,
      });
    },
    async fetchSingleDownloadableFileAction(_ctx, { churchId, fileId }) {
      return $http('v2').get(
        `${churchId ? `organisations/${churchId}/` : ''}downloadable_files/${fileId}`
      );
    },
    async downloadableFileAction(_ctx, { fileId, churchId }) {
      return $http('v2', { forFileDownload: true })
        .get(
          `${churchId ? `organisations/${churchId}/` : ''}downloadable_files/${fileId}/download`,
          {
            headers: { 'X-Is-Notifiable': 'On' },
          }
        )
        .then(async (response) => {
          // Download file
          await downloadFileFromResponse(response, 'file');
          return response;
        });
    },
    async downloadableResourceAction(_ctx, { resource, churchId }) {
      return $http('v2', { forFileDownload: true })
        .get(`organisations/${churchId}/resource_downloads/${resource}`, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .then(async (response) => {
          // Download file
          await downloadFileFromResponse(response, 'file');
          return response;
        });
    },
    /**
     * Search downloadable files for selection
     * This method can also fetch all available downloadable files
     * if no search query is provided
     * @param {*} ctx Context
     * @param {String} searchQuery
     * @returns
     */
    async loadDownloadableFilesForSearchSelect(_ctx, searchQuery) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .get('downloadable_files/select', {
            params: {
              searchQuery: searchQuery,
            },
          })
          .then((response) => {
            return resolve(response.data.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
  },
};
